import { render } from "./AccountSettings.vue?vue&type=template&id=6015cb27&scoped=true&lang=html"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"

import "./AccountSettings.vue?vue&type=style&index=0&id=6015cb27&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6015cb27"]])

export default __exports__